import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=fec95fb4&scoped=true&"
import script from "./FormSection.vue?vue&type=script&lang=ts&"
export * from "./FormSection.vue?vue&type=script&lang=ts&"
import style0 from "./FormSection.vue?vue&type=style&index=0&id=fec95fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec95fb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpandTransition,VIcon})
